import { render, staticRenderFns } from "./LoginMobil.vue?vue&type=template&id=23c35122"
import script from "./LoginMobil.vue?vue&type=script&lang=js"
export * from "./LoginMobil.vue?vue&type=script&lang=js"
import style0 from "./LoginMobil.vue?vue&type=style&index=0&id=23c35122&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports